import type { components } from '@social-studio/operator-client';
import { useQuery } from '@tanstack/react-query';
import { api, call } from '../../lib/api';

export type AiUsageMonth = components['schemas']['AiUsageMonthDto'];
export type AiJobTypeMonth = components['schemas']['AiJobTypeMonthDto'];
export type TrendMetric = components['schemas']['OperatorTrendDto']['metric'];

export const AI_USAGE_WINDOWS = [3, 6, 12] as const;
export const TREND_WINDOWS = [30, 90, 365] as const;
export const TREND_METRICS: readonly TrendMetric[] = [
  'ai_credits_month',
  'ai_runs_month',
  'posts_created_month',
  'published_month',
  'drafts',
  'approved',
  'photos',
  'knowledge_verified',
  'members',
];

/** AI use of one tenant per UTC month and job type, oldest month first (REQ-140-013). */
export function useTenantAiUsage(id: string, months: number) {
  return useQuery({
    queryKey: ['operator-tenant-ai-usage', id, months],
    queryFn: () => call(() => api.GET('/v1/operator/tenants/{id}/ai-usage', { params: { path: { id }, query: { months } } })),
    staleTime: 5 * 60_000,
  });
}

/** One figure per UTC day from the daily snapshots (REQ-140-016). */
export function useTenantTrend(id: string, metric: TrendMetric, days: number) {
  return useQuery({
    queryKey: ['operator-tenant-trend', id, metric, days],
    queryFn: () => call(() => api.GET('/v1/operator/tenants/{id}/trend', { params: { path: { id }, query: { metric, days } } })),
    staleTime: 5 * 60_000,
  });
}
